<template>
  <div>
    <slot />
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'IntervalMarkers',

  props: {
    /**
     * The delay of each marker
     */
    delay: {
      type: Number,
      required: false,
      default: 500,
    },

    /**
     * Should the markers fly in from `asc` 1 to x or `desc` x to 1
     */
    direction: {
      type: String,
      required: false,
      default: 'desc',
      validator: (value) => ['asc', 'desc'].includes(value),
    },

    /**
     * Should the fly in delay be quicker at the end
     */
    easing: {
      type: Boolean,
      required: false,
      default: true,
    },
  },

  data() {
    return {
      interval: null,
      count: 0,
      easeNumber: 0,
      intervalDelay: this.delay,
      nonVisibleMarkers: [],
    };
  },

  computed: {
    ...mapState({
      markers: (state) => state.markers.markers,
    }),
  },

  mounted() {
    this.markers.forEach((marker) => {
      if (marker.getVisible()) {
        this.$store.commit('markers/removeVisibleMarkers', marker.marker.id);
        marker.setVisible(false);
      } else {
        this.nonVisibleMarkers.push(marker.marker.id);
      }
    });

    if (this.direction === 'desc') {
      this.count = this.markers.length - 1;
    }

    if (this.easing) {
      this.easeNumber = this.delay / this.markers.length;
    }

    this.intervalFunc();
  },

  methods: {
    intervalFunc() {
      this.interval = setTimeout(() => {
        if (this.direction === 'asc') {
          this.countUp();
        } else {
          this.countDown();
        }

        this.intervalDelay -= this.easeNumber;
      }, this.intervalDelay);
    },

    countUp() {
      if (this.count < this.markers.length) {
        const marker = this.markers[this.count];

        if (!this.nonVisibleMarkers.includes(marker.marker.id)) {
          marker.setVisible(true);
        }

        this.count += 1;

        this.intervalFunc();
      } else {
        clearInterval(this.interval);
        this.setVisibleMarkers();
      }
    },

    countDown() {
      if (this.count > 0) {
        const marker = this.markers[this.count];

        if (!this.nonVisibleMarkers.includes(marker.marker.id)) {
          marker.setVisible(true);
        }

        this.count -= 1;

        this.intervalFunc();
      } else {
        clearInterval(this.interval);
        this.setVisibleMarkers();
      }
    },

    setVisibleMarkers() {
      this.markers.forEach((marker) => {
        if (marker.getVisible()) {
          this.$store.commit('markers/addVisibleMarkers', marker.marker.id);
        }
      });
    },
  },
};
</script>
